import type { PortalEstado } from '@contefy/shared';
import { useState } from 'react';
import { Alerta, Botao, Cartao, Titulo } from './ui';

export function Perguntas({
  pendencias,
  aoResponder,
}: {
  pendencias: PortalEstado['pendencias'];
  aoResponder: (id: string, resposta: string) => Promise<void>;
}) {
  const abertas = pendencias.filter((p) => !p.resolvida_em);
  if (abertas.length === 0) return null;
  return (
    <Cartao className="border-amber-200">
      <Titulo sub="Ficaram dúvidas ao conferir os documentos. Responda com suas palavras.">
        Perguntas da equipe
      </Titulo>
      <div className="space-y-4">
        {abertas.map((p) => (
          <Pergunta key={p.id} texto={p.descricao} aoResponder={(r) => aoResponder(p.id, r)} />
        ))}
      </div>
    </Cartao>
  );
}

function Pergunta({
  texto,
  aoResponder,
}: {
  texto: string;
  aoResponder: (r: string) => Promise<void>;
}) {
  const [resposta, setResposta] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);
  return (
    <div className="rounded-xl bg-amber-50 p-3">
      <p className="text-sm font-medium text-amber-950">{texto}</p>
      <textarea
        className="mt-2"
        rows={2}
        value={resposta}
        onChange={(e) => setResposta(e.target.value)}
        placeholder="Sua resposta"
      />
      {erro && (
        <div className="mt-2">
          <Alerta tipo="erro">{erro}</Alerta>
        </div>
      )}
      <Botao
        className="mt-2"
        variante="secundario"
        disabled={resposta.trim().length < 1}
        carregando={enviando}
        onClick={async () => {
          setEnviando(true);
          setErro(null);
          try {
            await aoResponder(resposta);
          } catch (e) {
            setErro((e as Error).message);
          } finally {
            setEnviando(false);
          }
        }}
      >
        Enviar resposta
      </Botao>
    </div>
  );
}
